export default __webpack_public_path__ + "static/media/lagos-ajah.77b1a400.webp";